package com.example.mystybag.appCore.model

import com.example.mystybag.core.model.CountryItem

data class PhoneSelectionBottomSheetUIState(
    val dialCode: String = "",
    val phoneNumber: String = "",
    val countries: List<CountryItem> = emptyList(),
    val showCountryPicker: Boolean = false,
    val isLoading: Boolean = false
)
